import React from 'react';
import Loading from '@shared/components/loading/Loading';
import { GamificationEconomiesMessage } from '@domain/navigation/interactive-header/gamification-economies/gamification-economies.styles';
import { getEconomyMessage } from './gamification-economies.utils';

export interface GamificationEconomiesReport {
    userId: string;
    economyType: string;
    economyValue: number;
}

export interface GamificationEconomiesProps {
    boardName: string;
    boardData: GamificationEconomiesReport[];
    loading: boolean;
}

export const GamificationEconomies = ({
    boardData,
    loading,
}: GamificationEconomiesProps) => (
    <>
        {
            loading
                ? <Loading height={20} spinnerSize={20} />
                : (
                    <GamificationEconomiesMessage>
                        {getEconomyMessage(boardData)}
                    </GamificationEconomiesMessage>
                )
        }
    </>
);
